"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _AVNURAH2cjs = require('../__chunks/AVNURAH2.cjs');
require('../__chunks/6P52IAFY.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');
require('../__chunks/UCZW3OGH.cjs');
require('../__chunks/XWMMMXUK.cjs');





var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');




var _3BSDKDKDcjs = require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/select/select-label.tsx
var _misc = require('@ariakit/core/utils/misc');
var TagName = "div";
var useSelectLabel = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useSelectLabel2({ store, ...props }) {
    const context = _AVNURAH2cjs.useSelectProviderContext.call(void 0, );
    store = store || context;
    _misc.invariant.call(void 0, 
      store,
      process.env.NODE_ENV !== "production" && "SelectLabel must receive a `store` prop or be wrapped in a SelectProvider component."
    );
    const id = _3BSDKDKDcjs.useId.call(void 0, props.id);
    const onClickProp = props.onClick;
    const onClick = _3BSDKDKDcjs.useEvent.call(void 0, (event) => {
      onClickProp == null ? void 0 : onClickProp(event);
      if (event.defaultPrevented) return;
      queueMicrotask(() => {
        const select = store == null ? void 0 : store.getState().selectElement;
        select == null ? void 0 : select.focus();
      });
    });
    props = {
      ...props,
      id,
      ref: _3BSDKDKDcjs.useMergeRefs.call(void 0, store.setLabelElement, props.ref),
      onClick,
      style: {
        cursor: "default",
        ...props.style
      }
    };
    return _misc.removeUndefinedValues.call(void 0, props);
  }
);
var SelectLabel = _PTOCUU2Dcjs.memo.call(void 0, 
  _PTOCUU2Dcjs.forwardRef.call(void 0, function SelectLabel2(props) {
    const htmlProps = useSelectLabel(props);
    return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
  })
);



exports.SelectLabel = SelectLabel; exports.useSelectLabel = useSelectLabel;
